import { render, staticRenderFns } from "./actualTab.vue?vue&type=template&id=3db9ae3a&scoped=true&"
import script from "./actualTab.vue?vue&type=script&lang=js&"
export * from "./actualTab.vue?vue&type=script&lang=js&"
import style0 from "./actualTab.vue?vue&type=style&index=0&id=3db9ae3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9ae3a",
  null
  
)

export default component.exports